import React from 'react';
import { TextWrapper, TextContent } from '@@Pages/ProductPage/Overview/styled';
export const Overview = ({ product, }) => {
    if (!product)
        return null;
    return (React.createElement(TextWrapper, null, (product === null || product === void 0 ? void 0 : product.description) && (React.createElement(TextContent, { dangerouslySetInnerHTML: { __html: product === null || product === void 0 ? void 0 : product.description } }))));
};
